import Immutable from 'immutable';


export function parseRuntime(val) {
	if (!val) {
		return null;
	}
	val = val.split(/[,\.:]/g);
	let res = 0;
	let mul = 1;
	let cnt = 0;
	for (let i = val.length - 1; (i >= 0) && (cnt < 3); i--, cnt++) {
		res += Math.abs(val[i]) * mul;
		mul *= 60;
	}
	if (isNaN(res)) {
		return null;
	}
	if (val[0] && val[0].startsWith('-')) {
		return -res;
	} else {
		return res;
	}
}

export function formatRuntime(val) {
	if (typeof val === 'number') {
		let pfx = '';
		if (val < 0) {
			pfx = '-';
			val = Math.abs(val);
		}
		let secs = (val % 60) + '';
		if (secs.length === 1) {
			secs = '0' + secs;
		}
		let mins = Math.floor(val / 60);
		if (mins < 60) {
			return pfx + Math.floor(val / 60) + ':' + secs;
		} else {
			let hours = Math.floor(mins / 60);
			mins = (mins % 60) + '';
			if (mins.length === 1) {
				mins = '0' + mins;
			}
			return pfx + hours + ':' + mins + ':' + secs;
		}
	} else {
		return '';
	}
}

export const EMPTY_RUNTIME_RANGE = Immutable.Map({
	type: 'runtimeRange',
	valid: true,
	from: null,
	to: null,
	text: ''
});

export function createRuntimeRange(from, to) {
	let text;
	if (from) {
		if (to) {
			text = formatRuntime(from, false) + ' - ' + formatRuntime(to, false);
		} else {
			text = formatRuntime(from, false) + ' - ';
		}
	} else {
		if (to) {
			text = ' - ' + formatRuntime(to);
		}
	}
	if (!text) {
		return EMPTY_RUNTIME_RANGE;
	}
	return EMPTY_RUNTIME_RANGE
		.set('from', from)
		.set('to', to)
		.set('text', text);
}

export function parseSearchRuntime(value) {
	if (typeof value !== 'string') {
		return EMPTY_RUNTIME_RANGE;
	}
	value = value.trim();
	if (!value) {
		return EMPTY_RUNTIME_RANGE;
	}
	const tokens = value.split('-');
	let from, to;
	if (tokens.length === 1) {
		if (tokens[0]) {
			from = parseRuntime(tokens[0]);
			to = parseRuntime(tokens[0]);
		} else {
			from = null;
			to = null;
		}
	} else {
		if (tokens[0]) {
			from = parseRuntime(tokens[0]);
		} else {
			from = null;
		}
		if (tokens[1]) {
			to = parseRuntime(tokens[1]);
		} else {
			to = null;
		}
	}
	let valid = true;
	if (isNaN(from)) {
		from = null;
		valid = false;
	}
	if (isNaN(to)) {
		to = null;
		valid = false;
	}
	const res = Immutable.Map({
		type: 'runtimeRange',
		valid,
		from,
		to,
		text: value
	});

	return res;
}

